<template>
    <div>
      <!-- Botón que abre el modal -->
      <button @click="showModal = true" class="bg-blue-600 hover:bg-blue-800 text-white px-4 py-2 rounded">
        {{ uiT('company.registerStandButton') }}
      </button>
  
      <!-- Modal -->
      <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-lg w-full max-w-2xl relative">
          <h2 class="text-xl font-bold mb-4">{{ uiT('company.title') }}</h2>
  
          <form @submit.prevent="submitForm">
            <!-- Parte 1: Datos generales -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label>{{ uiT('company.idType') }}</label>
                <select v-model="form.tipo_identificacion" class="input-style">
                  <option value="">-- Seleccione --</option>
                  <option value="CC">CC</option>
                  <option value="NIT">NIT</option>
                  <option value="PASAPORTE">PASAPORTE</option>
                </select>
              </div>
  
              <div>
                <label>{{ uiT('company.idNumber') }}</label>
                <input type="text" v-model="form.numero_identificacion" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.businessName') }}</label>
                <input type="text" v-model="form.razon_social" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.country') }}</label>
                <input type="text" v-model="form.pais" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.city') }}</label>
                <input type="text" v-model="form.ciudad" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.address') }}</label>
                <input type="text" v-model="form.direccion" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.phone') }}</label>
                <input type="text" v-model="form.telefono" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.currency') }}</label>
                <select v-model="form.moneda" class="input-style">
                    <option value="">-- Seleccione --</option>
                    <option value="USD">USD (Dólar)</option>
                    <option value="COP">COP (Peso Colombiano)</option>
                </select>
            </div>

              <div>
                <label>{{ uiT('company.website') }}</label>
                <input type="text" v-model="form.pagina_web" class="input-style">
              </div>
            </div>
  
            <hr class="my-4" />
  
            <!-- Parte 2: Representante legal -->
            <div class="mb-4 flex items-center gap-4">
                <label class="flex items-center cursor-pointer">
                    <span class="mr-2 font-medium text-gray-700">{{ uiT('registration.legalRepresentative') }}</span>
                    <div class="relative">
                    <input type="checkbox" v-model="soyRepresentante" class="sr-only peer" />
                    <div class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-green-500 transition-colors"></div>
                    <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-full"></div>
                    </div>
                </label>
            </div>

  
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label>{{ uiT('company.legalName') }}</label>
                <input type="text" v-model="form.nombre_representante_legal" class="input-style">
              </div>
  
              <div>
                <label>{{ uiT('company.legalEmail') }}</label>
                <input type="email" v-model="form.correo_electronico" class="input-style">
              </div>
  
              <template v-if="soyRepresentante">
                <div>
                  <label>{{ uiT('registration.phone') }}</label>
                  <input type="text" v-model="form.celular" class="input-style">
                </div>
  
                <div>
                  <label>{{ uiT('company.legalId') }}</label>
                  <input type="text" v-model="form.identificacion_representante_legal" class="input-style">
                </div>
  
                <div>
                  <label>{{ uiT('registration.position') }}</label>
                  <input type="text" v-model="form.cargo_representante_legal" class="input-style">
                </div>
              </template>
            </div>
  
            <!-- Botones -->
            <div class="mt-6 flex justify-end gap-3">
              <button type="button" @click="showModal = false" class="px-4 py-2 bg-gray-400 text-white rounded">{{ uiT('common.cancel') }}</button>
              <button type="submit" class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded">{{ uiT('common.save') }}</button>
            </div>
          </form>
        </div>
      </div>
      <!-- Modal de QR -->
<!-- Modal de QR -->
<div v-if="qrModalVisible" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
  <div class="bg-white p-8 rounded-lg text-center max-w-md relative" style="
    display: flex;
    flex-direction: column;
    align-items: center;
">
    
    <!-- Botón "X" -->
    <button @click="qrModalVisible = false" class="absolute top-2 right-2 text-gray-500 hover:text-black text-xl font-bold">
      ×
    </button>

    <h2 class="text-xl font-bold mb-4">{{ uiT('registration.qrTitle') }}</h2>
    <qrcode-vue :value="qrLink" :size="200" />

    <!-- Botón para ver ticket -->
    <div v-if="tokenUser && idGroup" class="mt-4">
      <a
        :href="`/api/ticket/${tokenUser}/${idGroup}`"
        target="_blank"
        class="inline-block mt-2 px-4 py-2 bg-blue-600 hover:bg-blue-800 text-white rounded"
      >
        {{ uiT('moderators.accessTicket') }}
      </a>
    </div>
  </div>
</div>

    </div>
  </template>
  
  <script>
  import QrcodeVue from 'qrcode.vue';
    import { userManagementI18nMixin } from "./i18n/userManagementI18n.js";

export default {
  mixins: [userManagementI18nMixin],
  components: {
    QrcodeVue
  },
  props: {
    eventoToken: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      showModal: false,
      qrModalVisible: false,
      qrLink: '',
      soyRepresentante: false,
      form: {
        tipo_identificacion: '',
        numero_identificacion: '',
        razon_social: '',
        pais: '',
        ciudad: '',
        direccion: '',
        telefono: '',
        moneda: '',
        pagina_web: '',
        celular: '',
        correo_electronico: '',
        nombre_representante_legal: '',
        identificacion_representante_legal: '',
        cargo_representante_legal: ''
      }
    };
  },
  methods: {
    async submitForm() {
      try {
        const response = await fetch('/api/empresa/guardar-por-evento', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token_evento: this.eventoToken,
            ...this.form
          })
        });

        const data = await response.json();

        if (response.ok) {
          this.showModal = false;

          // Si hay un link, mostramos el QR
          if (data.link) {
            this.qrLink = data.link;
            this.qrLink = data.link;
            this.tokenUser = data.token_user;
            this.idGroup = data.id_group;
            this.qrModalVisible = true;

          } else {
            alert(this.uiT('company.saved'));
          }
        } else {
          alert(this.uiT('company.saveError', { message: data.message || this.uiT('company.unexpectedError') }));
        }
      } catch (error) {
        alert(this.uiT('company.connectionError'));
      }
    }
  }
};

  </script>
  
  <style scoped>
  .input-style {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  .peer:checked ~ .peer-checked\:translate-x-full {
  transform: translateX(100%);
}
.qr-modal {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

  </style>
  
